<template>
  <main
    class="mobile-desktop-notice min-h-screen w-full bg-gray-50 text-gray-900 dark:bg-gray-950 dark:text-gray-100"
    style="font-family: 'Inter', sans-serif;"
  >
    <div class="flex min-h-screen items-center justify-center px-4 py-10 sm:px-6">
      <div class="w-full max-w-lg">
        <div class="mb-8 flex items-center justify-center gap-2.5">
          <img class="h-9 w-auto" src="@/assets/logo.png" alt="MetalNx" />
        </div>

        <div
          class="overflow-hidden rounded-xl border border-dashed border-gray-300/80 bg-gray-50 dark:border-white/15 dark:bg-white/[0.02]"
        >
          <div class="px-6 py-10 text-center sm:px-10 sm:py-12">
            <div
              class="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl border border-gray-200 bg-white text-[color:var(--v-primary-base)] shadow-sm dark:border-white/10 dark:bg-white/5 dark:shadow-none"
            >
              <v-icon size="32">mdi-monitor</v-icon>
            </div>

            <h1 class="mt-6 text-xl font-semibold tracking-tight text-gray-900 dark:text-gray-100">
              MetalNx is designed for desktop
            </h1>

            <p class="mt-3 text-sm text-gray-600 dark:text-gray-400">
              This platform is optimized for desktop use. Please access MetalNx from a desktop browser.
            </p>

            <div class="mt-7 flex justify-center">
              <a
                href="https://MetalNx.com"
                target="_blank"
                rel="noopener noreferrer"
                class="inline-flex items-center justify-center gap-2 rounded-xl bg-[color:var(--v-primary-base)] px-7 py-3 text-sm font-semibold text-white no-underline shadow-sm transition-opacity hover:opacity-90"
              >
                Visit MetalNx.com
                <v-icon size="18" color="white">mdi-open-in-new</v-icon>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { isMobileViewport } from '@/utils/viewport'

export default {
  name: "MobileDesktopNotice",
  mounted() {
    this.redirectIfSupported()
    this._onResize = () => this.redirectIfSupported()
    window.addEventListener('resize', this._onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._onResize)
  },
  methods: {
    redirectIfSupported() {
      if (!isMobileViewport()) {
        const target = this.$store.state.Login ? '/user/home' : '/login'
        this.$router.replace(target)
      }
    },
  },
};
</script>
